import React from "react"
import { StaticQuery, graphql } from 'gatsby'
import { FormattedMessage, injectIntl } from 'react-intl'
import Img from 'gatsby-image'
import { Link } from './localizedlink'
import { slugify } from '../utils'
import useAvatar from "../utility/useAvatar"
import User from '../images/svg-icons/user-light.svg'


const Speaker = ({ intl: { locale } }) => {
  const avatar = useAvatar();
  return (
    <StaticQuery
      query={graphql`
        query {
          speakersYaml {
            live {
              title
              speakers {
                title
                jobtitle
                img
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 260, quality: 100){
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
                workshop
                casestudy
                presentazione
                keynote
                socialconsulting
                lang
              }
            }
          }
        }
      `}
      render={data => {
        const liveSpeakers = data.speakersYaml.live.map(node => node.speakers.find(speaker => speaker.lang === locale));
        return (
          <section id="speaker" className="section text-center speaker clearfix" aria-labelledby="region-speaker">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-8 offset-md-2">
                  <h1 id="region-speaker" className="section__title">
                    <FormattedMessage id="speaker" />
                  </h1>
                  {liveSpeakers.map((speaker, i) => (
                    <React.Fragment key={speaker.title}>
                      <div className={`person ${i % 2 === 0 ? 'left' : 'right'}`} data-aos="fade-up">
                        <Link to={`/${slugify(speaker.title)}/`} title={speaker.title} className="person__link">
                          <figure className="person__figure">
                            {speaker.imageFile ? (
                              <Img fluid={speaker.imageFile.childImageSharp.fluid} alt={speaker.title} className="bio-detail__img" />
                            ) : (
                              <div className="person__img-wrapper">
                                <User />
                                <img src={avatar.publicURL} alt={speaker.title} className="person__img" />
                              </div>
                            )}
                            <div className="person__bullet">
                              {speaker.casestudy && <span className="casestudy"></span>}
                              {speaker.keynote && <span className="keynote"></span>}
                              {speaker.workshop && <span className="workshop"></span>}
                              {speaker.presentazione && <span className="presentazione"></span>}
                              {speaker.socialconsulting && <span className="social-consulting"></span>}
                            </div>
                            <div className="person__program">
                              {speaker.casestudy && <span className="casestudy"><FormattedMessage id="casestudy" /></span>}
                              {speaker.keynote && <span className="keynote"><FormattedMessage id="keynote" /></span>}
                              {speaker.workshop && <span className="workshop"><FormattedMessage id="workshop" /></span>}
                              {speaker.presentazione && <span className="presentazione"><FormattedMessage id="presentazione" /></span>}
                              {speaker.socialconsulting && <span className="social-consulting"><FormattedMessage id="social-consulting" /></span>}
                            </div>
                          </figure>
                          <span className="person__name">{speaker.title}</span>
                          <span className="person__role">{speaker.jobtitle}</span>
                          <span className="person__detail"><FormattedMessage id="continua>" /></span>
                        </Link>
                      </div>
                      {i % 2 === 1 && <div className="clear"></div>}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )
      }
    }
  />);
};

export default injectIntl(Speaker);